export default __webpack_public_path__ + "4824d5c6138979fc99ee3751e5b13e05.png";